import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "image-type-file",
  "use": "image-type-file-usage",
  "viewBox": "0 0 20 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 26\" aria-hidden=\"true\" id=\"image-type-file\"><path fill=\"#02a191\" d=\"M13.41 0H2a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6.58L13.41 0zM8.5 10a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 8.5 10zm6.968 10H4.473a.475.475 0 0 1-.377-.76l2.31-3.088a.471.471 0 0 1 .672-.086l1.83 1.468 2.825-3.346a.529.529 0 0 1 .844.046l3.33 4.933a.533.533 0 0 1-.44.833zM15 7a2 2 0 0 1-2-2V1l6 6h-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol